import React from "react"
import Marquee from "react-fast-marquee"

const MarqueeI = ({ data }) => {
  return (
    <Marquee className="tickerwrapper" direction="left" speed={50}>
      {data.map((item, index) => {
        return (
          <span key={`${item.text}-${index}`}>{item.text.toString()}</span>
        )
      })}
    </Marquee>
  )
}

export default MarqueeI
